import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import { DIRECTIONS } from './_constants';

export const VerticalChevronOutlinedIcon = ({
  width,
  height,
  fill,
  className,
  direction,
  ...rest
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='64 64 896 896'
      width={width}
      height={height}
      className={clsx('icon', 'icon-vertical-chevron-outlined', className, {
        'icon-vertical-chevron-outlined--up': direction === DIRECTIONS.UP,
        'icon-vertical-chevron-outlined--right': direction === DIRECTIONS.RIGHT,
        'icon-vertical-chevron-outlined--down': direction === DIRECTIONS.DOWN,
        'icon-vertical-chevron-outlined--left': direction === DIRECTIONS.LEFT
      })}
      {...rest}
    >
      <path
        fill={fill}
        d='M99.9928 198.007L99.9928 262.007C99.9928 266.407 103.593 270.007 107.993 270.007L795.993 270.007C800.393 270.007 803.993 266.407 803.993 262.007V198.007C803.993 193.607 800.393 190.007 795.993 190.007L107.993 190.007C103.593 190.007 99.9928 193.607 99.9928 198.007ZM99.9928 706.007H172.393C181.893 706.007 190.793 701.807 196.893 694.607L447.993 395.407L699.093 694.607C705.193 701.807 714.093 706.007 723.593 706.007H795.993C802.793 706.007 806.493 698.107 802.093 692.907L447.993 271.007L93.8928 692.907C92.9071 694.066 92.2748 695.484 92.0708 696.992C91.8669 698.499 92.0999 700.034 92.7421 701.413C93.3844 702.793 94.409 703.959 95.6942 704.773C96.9794 705.587 98.4713 706.016 99.9928 706.007Z'
      />
    </svg>
  );
};

VerticalChevronOutlinedIcon.defaultProps = {
  width: 15,
  height: 15,
  fill: 'currentColor',
  className: '',
  direction: 'up'
};

VerticalChevronOutlinedIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
  className: PropTypes.string,
  direction: PropTypes.oneOf(Object.values(DIRECTIONS))
};
